import ReviewScore from 'components/reviews/ReviewScore'
import ShowMoreText from 'components/ShowMoreText'
import TagList from 'components/display/TagList'
import Tag from 'components/display/Tag'
import ListingAlert from 'components/display/ListingAlerts'
import { regionPath } from 'routes/regionPath'

import { InfoWithIcon, SubSection } from './shared'
import { ListingProps } from '../types'

interface ListingOverviewProps {
  listing: ListingProps
  noDescription?: boolean
  showAvailabilityAlerts?: boolean
  openReviewModal: (arg: boolean) => any
}

const ListingOverview = ({
  listing,
  noDescription,
  showAvailabilityAlerts = false,
  openReviewModal,
}: ListingOverviewProps) => {
  return (
    <div>
      <SubSection style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
        <InfoWithIcon>
          <i
            className={`icon icon-${
              listing.listing_subcategory
                ? listing.listing_subcategory.slug
                : listing.listing_type.slug
            }`}
          />{' '}
          <span>
            {`${
              listing.listing_subcategory
                ? listing.listing_subcategory.name
                : listing.listing_type.name
            } in `}
            {listing.market && listing.region && (
              <a href={regionPath(listing.market.slug, listing.region.slug)}>
                {listing.location.name}
              </a>
            )}
          </span>
        </InfoWithIcon>

        <ReviewScore
          score={listing.review_score}
          count={listing.review_count}
          size="medium"
          handleShowReviews={() => openReviewModal(true)}
        />
      </SubSection>

      {listing.features && (
        <SubSection
          // @ts-ignore -- not typed yet
          lessMargin
        >
          <TagList>
            {listing.features.map((f) => (
              <Tag key={f.slug} icon={f.slug}>
                {f.name}
              </Tag>
            ))}
          </TagList>
        </SubSection>
      )}

      {showAvailabilityAlerts && (
        <ListingAlert
          listingId={listing?.id?.toString()}
          marketName={listing?.market?.name}
        />
      )}

      {!noDescription && (
        <ShowMoreText lines={5}>{listing.description}</ShowMoreText>
      )}
    </div>
  )
}

export default ListingOverview
